// Local translations
export const T = {
  en_GB: {
    name: "Name",
    language: "Language",
    status: "Status",
    followup: "Followup",
    multiGoal: "Multi-Goal",
    multiPortfolio: "Multi-Portfolio",
    yes: "Yes",
    no: "No",
    actions: "Actions",
    noFlowsYet: "No flows yet. Create your first flow to get started.",
    cannotToggleFlow: "Cannot Change Flow Status",
    cannotToggleFollowup: "Cannot Change Followup Support",
    deleteFlow: "Delete Flow",
    deleteFlowConfirmation: (name: string) => `Are you sure you want to delete "${name}"?`,
    deleteFlowWithInstances: (name: string, count: string) =>
      `Are you sure you want to delete "${name}"? This will also delete ${count} advice session(s) created with this flow.`,
    delete: "Delete",
    edit: "Edit",
    clone: "Duplicate",
    cancel: "Cancel",
    error: "Error",
    ok: "OK",
    failedToDeleteFlow: "Failed to delete flow",
  },
  nb_NO: {
    name: "Navn",
    language: "Språk",
    status: "Status",
    followup: "Oppfølging",
    multiGoal: "Flermål",
    multiPortfolio: "Flerportefølje",
    yes: "Ja",
    no: "Nei",
    actions: "Handlinger",
    noFlowsYet: "Ingen flyter ennå. Opprett din første flyt for å komme i gang.",
    cannotToggleFlow: "Kan ikke endre flytstatus",
    cannotToggleFollowup: "Kan ikke endre oppfølgingsstøtte",
    deleteFlow: "Slett flyt",
    deleteFlowConfirmation: (name: string) => `Er du sikker på at du vil slette "${name}"?`,
    deleteFlowWithInstances: (name: string, count: string) =>
      `Er du sikker på at du vil slette "${name}"? Dette vil også slette ${count} rådgivningsøkt(er) opprettet med denne flyten.`,
    delete: "Slett",
    edit: "Rediger",
    clone: "Dupliser",
    cancel: "Avbryt",
    error: "Feil",
    ok: "OK",
    failedToDeleteFlow: "Kunne ikke slette flyt",
  },
} as const;
